import { GetAllPlatformCatalogVersionsParams } from "@bvhi/backend-api/apis/model/getAllPlatformCatalogVersionsParams";
import { PlatformCatalogVersionSortByParam } from "@bvhi/backend-api/apis/model/platformCatalogVersionSortByParam";
import { PlatformCatalogVersionSortParameter } from "@bvhi/backend-api/apis/model/platformCatalogVersionSortParameter";
import { createFileRoute } from "@tanstack/react-router";
import { WithErrorBoundary } from "../../../hoc/with-error-boundary";
import { withPermissionCheck } from "../../../hoc/with-permission-check";
import { CatalogsUpdateView } from "../../../views/app/catalog/catalogs/update/catalogs-update-view";

export const Route = createFileRoute("/_main/app/catalogs/catalog/$catalogId/")({
  validateSearch: (search: Record<string, unknown>): GetAllPlatformCatalogVersionsParams => {
    return {
      page: Number(search?.page ?? 0),
      size: Number(search?.size ?? 25),
      sort: (search?.sort as PlatformCatalogVersionSortParameter) || [PlatformCatalogVersionSortByParam.VERSION_DESC],
    };
  },
  component: () =>
    WithErrorBoundary({
      Component: withPermissionCheck({ Component: CatalogsUpdateView }),
    }),
});
